export const REQUIRED_PHOTOS_AMOUNT = 15;
